module.exports = __webpack_public_path__ + "static/img/p12H.4100d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/P12H/p12H.png
// module id = BfDu
// module chunks = 0